import React from "react";
import "./Ourvision.css";

// const corevalue1 =  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742210858/v1_invzl2.png";

const secondimg =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742273127/02_satz32.png";
const thirdimg =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742273207/03_mm4xna.png";
const fourthimg =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742273174/04_kqlxml.png";
const fifthimg =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742273166/25_ozhy9t.png";
const sixthimg =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742273134/06_ecs3mp.png";
const seventhimg =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742273143/07_oysjsh.png";
const eigthimg =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742273270/08_bw9jz6.png";
const progressimg = "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742548159/progress_v95esn.png";

const Ourvision = () => {
  return (
    <div className="ourvision">
      {/* Heading */}
      <div className="about-dasmesh-value-purpos-hding">
        <h3>OUR VISION</h3>
      </div>

      {/* Second section */}
      <div className="wedream">
        <div className="wedream1">
          <div className="dreamimg">
            <img src={secondimg} alt="" />
          </div>
          <div className="dreamcontent">
            <div className="dream1">
              <p>
                Across the globe, DASMESH is changing the way farmers work. From
                the enhanced productivity of our harvesters to the efficiency of
                combine harvesters, DASMESH is helping maximize ylelds, lawer
                Input costs, optimize profits and reduce operator fatigue.
              </p>
            </div>
            <div className="dream1">
              <p>
                Presently, India is the largest manufacturer of harvesters in
                the wild, accounting for about 1/3rd of the global production.
                The future will see us taking majority of market share in
                combine harevsters and other farming equipments. We have
                realized that Tractor operated combine harvester, costing only
                25-30% of the self propelled combine, has been a good innovation
                and this machine can be owned individually by farmers. So, we
                plan to innovate and develop such products as fit the budget of
                each farmer and bring him incredible advantages too.
              </p>
            </div>
            <div className="dream1">
              <p>
                We aim to increase our production capacity as well as commercial
                spread. A big team that shares common dreams has been chalking
                out plans to be the best and most trusted name in
                farming equipments
              </p>
            </div>
          </div>
        </div>

        <div className="wedreamimg">
          <img src={thirdimg} alt="" />
        </div>
      </div>

      {/* Third section */}
      <div className="transforming">
        <div className="transform1">
          <div className="transform1img">
            <img src={fourthimg} alt="" />
          </div>

          <div className="transform1content">
            <div className="transform2">
              <div className="transform2img">
                <img src={fifthimg} alt="" />
              </div>
              <div className="transform2content">
                <ul>
                  <li>Diversification Internationally - Become Number One</li>
                  <li>Innovating low maintenance products and technologies</li>
                  <li>Customer-centric product range</li>
                  <li>Benefit for the farmer at all stages</li>
                  <li>Utility and quality for everyone</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="transformright">
          <div className="trheading">
            <p className="textblack">"TRANFORMING AGRICULTURE,</p>
            <p>&nbsp;&nbsp;GROWING POSSIBILITIES, &nbsp;&nbsp;GLOBALLY"</p>
          </div>

          <div className="trtext">
            <p className="trtextbold">
              "Pioneering Quality, Owning the Market"
            </p>
            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"At
              DASMESH, our mission is clear: empowering farmers, boosting
              productivity, and expanding opportunities worldwide. With a strong
              commitment to innovation and customer satisfaction, we've
              established a global presence, serving happy customers across all
              continents.
            </p>
            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Leveraging
              technology advancements, we're driving agricultural productivity
              and self-reliance for nations. Our international footprint spans
              South Korea, Bangladesh, Myanmar, Algeria, Afghanistan, Pakistan,
              Sri Lanka and Iraq.
            </p>
            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Yet,
              this is just the beginning. Our vision is bold: to become the
              global leader in agriculture, setting the standard for excellence.
              We won't settle for less.
            </p>
          </div>
        </div>
      </div>

      {/* Fourth section */}
      <div className="greener">
        <div className="greenerimg">
          <img src={sixthimg} alt="" />
        </div>
        <div className="greenercontent">
          <p className="gu">ENVISIONING A</p>
          <p className="gl">GREENER TOMORROW</p>

          <div className="greencontent">
            <div className="greenimg">
              <img src={seventhimg} alt="" />
            </div>
            <div className="greencontent1">
              <p>
                Because we are so attached to the mother earth and the farmer
                who toils selflessly, we take our responsibility towards ecology
                and community very seriously.
              </p>
              <p>
                DASMESH ensures manufacturing of world class Combine Harvesters
                and farm equipments with a sustainable approach and with full
                care towards the ecological balance. The group also promotes
                best environment care & practices as part of its Corporate
                Social Responsibility programme.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Fifth section */}
      <div className="progresss mb-4">
        <div className="progressleft">
          <img src={eigthimg} alt="" />
        </div>
        <div className="progressright">
          <div className="prupper">
            <img src={progressimg} alt="" />
          </div>
          <div className="prlower">
            <div className="prl1">
              <hr />
              <p>
                "Uncompromising quality assurance at every step guarantees
                world-class standards, delivering exceptional performance
                and reliability."
              </p>
            </div>
            <div className="prl2">
              <p>
                "At DASMESH MECHANICAL WORKS (P) LTD., we're committed to
                delivering cutting-edge products that revolutionize farming. Our
                dedicated Research, Design, Development, and Testing Department
                drives innovation, harnessing the latest technology to create
                harvesters tailored to evolving agricultural needs. With a
                legacy built on research-driven innovation, we prioritize safety
                and efficacy in every product. Anticipating the future of
                agriculture, we cater to diverse crops and farming methods,
                ensuring your present success. Our ongoing R&D efforts fuel
                continuous improvement, yielding better solutions for a brighter
                agricultural future. Our customer-centric approach ensures
                timely support, training, and service, empowering farmers to
                optimize their operations. Join us in revolutionizing farming
                for a more sustainable tomorrow."
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Ourvision;
